export default __webpack_public_path__ + "static/media/noImageFound.99fd704d.jpg";